// extracted by mini-css-extract-plugin
module.exports = {"rainbow":"Shop_rainbow__OsFk_","hero":"Shop_hero__DkyDD","card":"Shop_card__v5IkK"};